<template>
  <div id="app" class="container full-window test">
    <common_header></common_header>
    <router-view></router-view>
    <common_footer></common_footer>
  </div>
</template>

<script>
// 作成したヘッダーコンポーネントをインポート
import common_header from "./views/Header.vue";
import "@fortawesome/fontawesome-free/css/all.css";
import "@fortawesome/fontawesome-free/js/all.js";
import common_footer from "./views/Footer.vue";

export default {
  name: "App",
  components: {
    common_header,
    common_footer
  }
};
</script>

<style lang="scss">
// Import Bulma's core
@import "~bulma/sass/utilities/_all";
@import "~bulma/sass/layout/footer";

// over write bulma css
$footer-padding: 1rem 1.5rem;
$section-padding: 1rem 1.5rem;

// Import Bulma and Buefy styles
@import "~bulma";
@import "~buefy/src/scss/buefy";
</style>


<style>
html {
  height: 100%;
  margin: 0;
  padding: 0;
}

body {
  height: 100%;
  margin: 0;
  padding: 0;
}

.test {
  display: flex;
  min-height: 100vh;
  flex-direction: column;
}

.full-window {
  height: 100%;
  margin: 0;
  padding: 0;
  width: 100%;
  max-width: 100%;
}

.flap-long-word {
  word-wrap: break-word;
}

.is-site-coler {
  background-color: #ffc94c;
  border-color: transparent;
  color: #fff;
}
</style>
